export default {
  path: '/error-thresholds',
  component: () =>
    import(
      '@/components/pages/ErrorThresholds/ErrorThresholds.vue'
    )
}
